var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { getStyleNames } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { ListRow } from '../../Select.styled';
import { disabledStyles, focusedRowStyles, groupedItemStyles, fixedRowListStyles, fixedRowListStylesSelected, } from '../../../styles/legacy';
import { disabledStyles as disabledStylesCitrus2022, focusedRowStyles as focusedRowStylesCitrus2022, groupedItemStyles as groupedItemStylesCitrus2022, fixedRowListStyles as fixedRowListStylesCitrus2022, fixedRowListStylesSelected as fixedRowListStylesSelectedCitrus2022, } from '../../../styles/citron';
var FixedSizeListRow = function (_a) {
    var _b;
    var index = _a.index, id = _a.id, isFocused = _a.isFocused, isMulti = _a.isMulti, isScrolling = _a.isScrolling, isScrollingPlaceholderText = _a.isScrollingPlaceholderText, style = _a.style, data = _a.data, onChange = _a.onChange, onMouseHover = _a.onMouseHover, renderItem = _a.renderItem;
    var isCitron = useTheme().citrus2022;
    if (index > data.length - 1)
        return null;
    var evenOrOdd = index % 2 ? 'ListItemOdd' : 'ListItemEven';
    var rowId = "".concat(id, "-select-row-").concat(index);
    var noHeaderCursor = __assign({ cursor: 'unset' }, (!isMulti && { color: '#666666' }));
    var fixedRowListStylesObj = isCitron ? fixedRowListStylesCitrus2022 : fixedRowListStyles;
    var fixedRowListStylesSelectedObj = isCitron ? fixedRowListStylesSelectedCitrus2022 : fixedRowListStylesSelected;
    var disabledStylesObj = isCitron ? disabledStylesCitrus2022 : disabledStyles;
    var focusedRowStylesObj = isCitron ? focusedRowStylesCitrus2022 : focusedRowStyles;
    var groupedItemStylesObj = isCitron ? groupedItemStylesCitrus2022 : groupedItemStyles;
    var emotionObj = (_b = {},
        _b[emotionCss(fixedRowListStylesObj)] = true,
        _b[emotionCss(fixedRowListStylesSelectedObj)] = !data[index].disabled && data[index].selected,
        _b[emotionCss(focusedRowStylesObj)] = !data[index].disabled && isFocused && !data[index].selected,
        _b[emotionCss(groupedItemStylesObj)] = data[index].groupId && !data[index].header,
        _b[emotionCss(noHeaderCursor)] = !data[index].disabled && !isFocused && data[index].header,
        _b[emotionCss(disabledStylesObj)] = data[index].disabled,
        _b[emotionCss(style)] = true,
        _b["".concat(evenOrOdd)] = true,
        _b);
    var classes = cx(emotionObj);
    var styleNames = {
        fixedRowListStylesObj: emotionObj[emotionCss(fixedRowListStylesObj)],
        fixedRowListStylesSelectedObj: emotionObj[emotionCss(fixedRowListStylesSelectedObj)],
        focusedRowStylesObj: emotionObj[emotionCss(focusedRowStylesObj)],
        groupedItemStylesObj: emotionObj[emotionCss(groupedItemStylesObj)],
        noHeaderCursor: emotionObj[emotionCss(noHeaderCursor)],
        disabledStylesObj: emotionObj[emotionCss(disabledStylesObj)],
    };
    var emptyCreatable = function (event) {
        if (event.type !== 'touchstart')
            event.preventDefault();
        event.stopPropagation();
        data[index].onMouseDown();
    };
    if (data[index].creatable) {
        return (React.createElement(ListRow, { className: classes, onMouseDown: emptyCreatable, onTouchStart: emptyCreatable, styleNames: getStyleNames(styleNames) }, renderItem ? renderItem(data[index]) : data[index].label));
    }
    var emptyMouseDown = function (event) {
        if (event.type !== 'touchstart')
            event.preventDefault();
        event.stopPropagation();
    };
    if (data[index].empty) {
        return (React.createElement(ListRow, { className: classes, onMouseDown: emptyMouseDown, onTouchStart: emptyMouseDown, styleNames: getStyleNames(styleNames) }, renderItem ? renderItem(data[index]) : data[index].label));
    }
    var handleRowSelection = function (event) {
        if (event.type !== 'touchstart')
            event.preventDefault();
        event.stopPropagation();
        if (onChange)
            onChange(data[index].optionsIndex);
    };
    var toggleFocus = function () {
        onMouseHover === null || onMouseHover === void 0 ? void 0 : onMouseHover(index);
    };
    var singleRow = function () {
        var label = data[index].label;
        var notScrollingTernary = function () { return (renderItem ? renderItem(data[index]) : label); };
        return (React.createElement(ListRow, { className: classes, id: rowId, onTouchStart: handleRowSelection, onMouseDown: handleRowSelection, onMouseEnter: toggleFocus, styleNames: getStyleNames(styleNames), title: label }, isScrolling ? isScrollingPlaceholderText || 'scrolling' : notScrollingTernary()));
    };
    return singleRow();
};
FixedSizeListRow.defaultProps = {
    __TYPE: 'FixedSizeListRow',
};
export default FixedSizeListRow;
